const REQUIREMENT_TYPES = {
  complexity: "complexity",
  maturity: "maturity",
  additional: "additional"
};

export default REQUIREMENT_TYPES;
